<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14">
    <slot />
    <g fill="none" fill-rule="evenodd">
      <path :fill="color" d="M0 13H18V14H0z" />
      <rect width="3" height="11" x="10.5" y="2.5" :stroke="color" rx="1" />
      <path
        :stroke="color"
        d="M10.257.852c-.11-.066-.244-.09-.378-.056l-6 1.5c-.112.028-.206.091-.273.177-.067.086-.106.193-.106.308V13c0 .138.056.263.146.354.09.09.216.146.354.146h6c.138 0 .263-.056.354-.146.09-.09.146-.216.146-.354L10.257.852z"
      />
      <circle cx="8.5" cy="8" r="1" :fill="color" />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
